import React, {useState, useEffect} from 'react'
import {Box, Text} from '@fuegokit/react'
import {VerticalPositionProvider, RuleBuilderStep, RuleBuilderSteps} from '../../../src/experimental/RuleBuilder'

const Content = ({index, ...rest}) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 6,
        borderRadius: 2,
        backgroundColor: 'elevation.surface.sunken'
      }}
      {...rest}
    >
      <Text>Content for the step</Text>
    </Box>
  )
}

const StyledRuleBuilderStepExample = () => {
  const [domLoaded, setDomLoaded] = useState(false)
  useEffect(() => {
    setDomLoaded(true)
  }, [])
  return (
    <>
      {domLoaded && (
        <VerticalPositionProvider>
          <RuleBuilderSteps>
            <RuleBuilderStep
              isCompletedStep={false}
              isSelected={false}
              isLastStep={false}
              index={0}
              condition={'when'}
              labe={'When'}
              onSelect={() => {
                alert('you selected the step')
              }}
            >
              <Content index={0} />
            </RuleBuilderStep>
            {/** no-op since we calculate isLastStep based on num of children */}
            <li style={{listStyle: 'none'}}></li>
          </RuleBuilderSteps>
        </VerticalPositionProvider>
      )}
    </>
  )
}
export default StyledRuleBuilderStepExample
